// extracted by mini-css-extract-plugin
export default {"overlay":"mA-z","bodyOpen":"nA-z","content":"oA-z","header":"pA-z","close":"qA-z","closeNoHeading":"rA-z"};